var _rect, _rect2, _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDuurzaamheidBombshell = function SvgDuurzaamheidBombshell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33203,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.33203,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    stroke: "#E2DFDF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8477,
    cy: 65.9023,
    r: 15.9023,
    fill: "#E6C4C1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1856_689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 17,
    width: 65,
    height: 66
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8223 17.9908H82.8412V82.0098H18.8223V17.9908Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1856_689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8328 80.1338H28.3262V58.8775H50.8328V80.1338Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.832 80.1338H73.3387V58.8775H50.832V80.1338Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2059 47.6236H20.6992L28.3265 58.877H50.8331L43.2059 47.6236Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4612 47.6236H80.9679L73.3406 58.877H50.834L58.4612 47.6236Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7055 32.1328C58.3232 35.2404 50.834 32.3453 50.834 32.3453C50.834 32.3453 52.0714 24.4118 57.4537 21.3043C62.836 18.1969 70.3252 21.092 70.3252 21.092C70.3252 21.092 69.0879 29.0253 63.7055 32.1328Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2134 21.3043C49.5957 24.4118 50.8331 32.3452 50.8331 32.3452C50.8331 32.3452 43.3438 35.2404 37.9615 32.1329C32.5792 29.0253 31.3418 21.0919 31.3418 21.0919C31.3418 21.0919 38.831 18.1968 44.2134 21.3043Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5796 26.719L50.834 32.3457",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0879 26.719L50.8335 32.3457",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.834 45.748V32.3447",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgDuurzaamheidBombshell;